import { handleActions } from 'redux-actions';
import apiCaller from 'client/util/apiCaller';

const FETCH_SALESFORCE_PROPERTIES_START = 'FETCH_SALESFORCE_PROPERTIES_START';
const FETCH_SALESFORCE_PROPERTIES_SUCCESS = 'FETCH_SALESFORCE_PROPERTIES_SUCCESS';
const FETCH_SALESFORCE_PROPERTIES_FAILURE = 'FETCH_SALESFORCE_PROPERTIES_FAILURE';

const initialState = {
  properties: [],
  loading: false,
  lastFetched: null,
  error: null,
};

export const SalesforcePropertiesReducer = handleActions(
  {
    [FETCH_SALESFORCE_PROPERTIES_START]: state => ({
      ...state,
      loading: true,
      error: null,
    }),
    [FETCH_SALESFORCE_PROPERTIES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      properties: action.payload,
      lastFetched: Date.now(),
      error: null,
    }),
    [FETCH_SALESFORCE_PROPERTIES_FAILURE]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload,
    }),
  },
  initialState,
);

// Selectors
export const getSalesforceProperties = state => state.salesforceProperties.properties;
export const getSalesforcePropertiesLoading = state => state.salesforceProperties.loading;
export const getSalesforcePropertiesLastFetched = state => state.salesforceProperties.lastFetched;

// Thunk to fetch properties if not cached or cache expired (5min TTL)
export const fetchSalesforcePropertiesIfNeeded = () => async (dispatch, getState) => {
  const state = getState();
  const lastFetched = getSalesforcePropertiesLastFetched(state);
  const loading = getSalesforcePropertiesLoading(state);
  if (loading) {
    // Already fetching, don't start another
    return;
  }
  if (lastFetched && Date.now() - lastFetched < 5 * 60 * 1000) {
    // Cache valid
    return;
  }
  dispatch({ type: FETCH_SALESFORCE_PROPERTIES_START });
  try {
    const res = await apiCaller(dispatch, 'integrations/salesforce/properties');
    dispatch({ type: FETCH_SALESFORCE_PROPERTIES_SUCCESS, payload: Array.isArray(res) ? res : [] });
  } catch (err) {
    dispatch({
      type: FETCH_SALESFORCE_PROPERTIES_FAILURE,
      payload: err.message || 'Failed to fetch',
    });
  }
};
